import React, { useState } from "react";
import "./updateTerminal.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { IconButton } from "@mui/material";
import { requestType, terminalType } from "../../../types/GlobalType";
import { accountService } from "../../../_services/accountServices";
import toast, { LoaderIcon } from "react-hot-toast";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: terminalType | undefined;
  dispatchReload: () => void;
}
const UpdateTerminal = (props: Props) => {
  const [terminalDesignation, setterminalDesignation] = useState(
    props.data?.terminal_designation
  );
  const [terminalId, setTerminalId] = useState(props.data?.terminal_uid);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const handleUpdateTerminal = async () => {
    if (!terminalDesignation?.toString().length) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez le nom du terminal",
      });
    }
    if (!terminalId?.toString().length) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez l'Id du terminal",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    try {
      let data = { designation: terminalDesignation, uid: terminalId };
      const response = await API_CONFIG.TERMINAL.update(
        props.data?.terminal_id,
        data,
        token
      );
      if (response.data.status === 200) {
        toast.success("Mis à jour effectuée avec succès", { duration: 3000 });
        setterminalDesignation("");
        setTerminalId("");
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  return (
    <div className="UpdateTerminal">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <SchoolOutlined className="ico" />
              <span>Modification - Terminal</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}

          <div className="item">
            <label>Désignation</label>
            <input
              placeholder="Identifiant"
              type="text"
              value={terminalDesignation}
              onChange={(e) => setterminalDesignation(e.target.value)}
            />
          </div>
          <div className="item">
            <label>Terminal ID</label>
            <input
              placeholder="Numééro ID"
              type="text"
              value={terminalId}
              onChange={(e) => setTerminalId(e.target.value)}
            />
          </div>
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={handleUpdateTerminal}>Mettre à jour</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateTerminal;
